<template>
	<div id="announcements" class="announcements alert">
		<button type="button" class="show-more-tab" @click="showMore">
			<span>
				<font-awesome-icon icon="angle-up" v-if="isActive"></font-awesome-icon>
				<font-awesome-icon icon="angle-down" v-else></font-awesome-icon>
			</span>
			<span class="sr-only">
				<span v-if="isActive">{{ $t('MAIN_CONTENT.Announcements.labelLess') }}</span>
				<span v-else>{{ $t('MAIN_CONTENT.Announcements.labelMore') }}</span>
				{{ $t('MAIN_CONTENT.Announcements.labelAnnouncements') }}
			</span>
		</button>
		<div class="panel sapphire-panel-info">
			<div class="panel-heading">
				<button type="button"
								class="close"
								data-target="#sannouncements"
								data-dismiss="alert"
								aria-label="Close"
								v-if="showDismiss">
					<span aria-hidden="true">&times;</span>
				</button>
				<h2 class="panel-title">{{ title }}</h2>
			</div>
			<div class="panel-body" :class="{'restrict-height': !isActive}">
				<span :key="item.ANNOUNCEMENT_RID" v-for="(item, index) in announcements">
					<h4 v-if="!!item.SCHOOL_TITLE">
						<strong>{{ item.SCHOOL_TITLE }}</strong>
					</h4>
					<h4 v-else>
						<strong>{{ $t('MAIN_CONTENT.Announcements.labelDistrictWideAnnouncement') }}</strong>
					</h4>
					<div v-html="item.ANNOUNCEMENT"></div>
					<hr v-if="index < announcements.length - 1" />
				</span>
			</div>
			<button type="button" class="show-more" @click="showMore">
				<span v-if="isActive">{{ $t('MAIN_CONTENT.Announcements.labelLess') }}</span>
				<span v-else>{{ $t('MAIN_CONTENT.Announcements.labelMore') }}</span> 
				{{ $t('MAIN_CONTENT.Announcements.labelAnnouncements') }}
			</button>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Announcements',
		props: {
			'title': {
				type: String,
				default: ''
			},
			'announcements': {
				type: Array,
				default() {
					return [];
				}
			},
			'showDismiss': {
				type : Boolean,
				default: true
			}
		},
		data() {
			return {
				isActive: false
			};
		},
		methods: {
			showMore() {
				this.isActive = !this.isActive;
			}
		}
	}
</script>
